/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {AppSharedModule} from '../app-shared.module';
import {ReportWidgetsModule} from '../../report/report-widgets.module';
import {BurnRateChartComponent} from './burn-rate-chart.component';
import {ChartOptionsComponent} from './chart-options/chart-options.component';
import {ChartOptionsFieldsModalComponent} from './chart-options/chart-options-fields-modal.component';
import {ExtDemPerformanceChartComponent} from './ext-dem-performance-chart.component';
import {HeatmapComponent} from './heatmap.component';
import {LineChartComponent} from './line-chart.component';
import {PerformanceChartComponent} from './performance-chart.component';
import {PerformanceChartHostComponent} from './performance-chart-host.component';
import {PerformanceTotalsComponent} from './performance-totals.component';
import {PerfTotalComponent} from './perf-total-component';
import {RelatedDataChartComponent} from './related-data-chart.component';
import {RelatedDataDomainComponent} from './related-data-domain.component';
import {RelatedDataLocationComponent} from './related-data-location.component';
import {RelatedDataTrafficComponent} from './related-data-traffic.component';
import {SparkChartComponent} from './spark-chart.component';
import {SpeedoComponent} from './speedo.component';

const CHARTS = [
  SparkChartComponent,
  HeatmapComponent,
  SpeedoComponent,
  BurnRateChartComponent,
  PerfTotalComponent,
  PerformanceChartComponent,
  ExtDemPerformanceChartComponent,
  PerformanceTotalsComponent,
  ChartOptionsComponent,
  ChartOptionsFieldsModalComponent,
  PerformanceChartHostComponent,
  RelatedDataChartComponent,
  LineChartComponent,
  RelatedDataLocationComponent,
  RelatedDataDomainComponent,
  RelatedDataTrafficComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    PopoverModule,
    BsDatepickerModule,
    TimepickerModule,
    ReportWidgetsModule
  ],
  declarations: CHARTS,
  exports: CHARTS
})
export class ChartsModule {
}
